module.exports = __webpack_public_path__ + "static/media/YM83_5.142900b1.jpg";